export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11318.7a6bcde2.jpg";